// extracted by mini-css-extract-plugin
module.exports = {"determined":"Logo_determined__2NjWi","horizontal":"Logo_horizontal__1-VTY","vertical":"Logo_vertical__1bm5X","hpe":"Logo_hpe__3d1VL"};